import { filter } from 'ramda'
import { FilterContentfulClient } from '../typings/graphql'

const hasFields = (n: FilterContentfulClient) => (n.id && n.name ? true : false)

export function nonNullClients(items: FilterContentfulClient[]): any[] {
  return filter(hasFields, items)
}
